// Target landing page: flavor switcher for the "Shop at Target" section.
if (!customElements.get('tgt-flavor-picker')) {
  customElements.define(
    'tgt-flavor-picker',
    class TgtFlavorPicker extends HTMLElement {
      connectedCallback() {
        this.options = [...this.querySelectorAll('[data-flavor-option]')];
        this.options.forEach((option) => {
          option.addEventListener('click', () => this.select(option.dataset.index));
        });
      }

      select(index) {
        const option = this.options.find((el) => el.dataset.index === index);
        if (!option) return;

        this.querySelectorAll('[data-flavor-option], [data-flavor-slide]').forEach((el) => {
          const isActive = el.dataset.index === index;
          el.classList.toggle('is-active', isActive);
          if (el.hasAttribute('aria-pressed')) el.setAttribute('aria-pressed', isActive);
        });
        this.querySelectorAll('[data-flavor-name]').forEach((el) => {
          el.textContent = option.dataset.title;
          el.style.color = option.dataset.color;
        });
        this.querySelectorAll('[data-flavor-url]').forEach((el) => {
          el.href = option.dataset.url;
        });
      }
    }
  );
}
